<template lang="pug">
  v-container(fluid).pa-0.card-video
    v-card.card-video
      v-snackbar(v-model='snackbar.show' :color='snackbar.color' center top :timeout="4000")
        | {{snackbar.message}}
      v-btn(v-if="isMobile" fab x-small color="primary" @click="hangUp").rtc-close-btn
        v-icon(size="20") mdi-close
      v-row
        v-col(cols="12" md="6" style="padding-top: 0")
          .video(style="position: relative")
            span.video__status {{status}}
            video#remoteVideo(v-show="status !== 'Llamada en espera' && status !== 'Fallo de conexión.' && status !== 'Desconectado...'" autoplay="" playsinline="").video__remote
            v-img(v-if="status === 'Llamada en espera' || status === 'Desconectado...' || status === 'Fallo de conexión.'" src="@/assets/images/background-tender-black-and-white.png").video__remote
            //- Local video
            v-img(v-if="!cameraOn" src="@/assets/logo.png").video__local
            video#localVideo(muted="" autoplay="" playsinline="").video__local
            // Buttons
            .buttonsVideo
              v-btn(text fab small @click="openCamera" color="primary")
                v-icon(v-if="!cameraOn" size="25") mdi-camera-off
                v-icon(v-else size="25") mdi-camera
              v-btn(text fab small @click="openAudio" color="primary")
                v-icon(v-if="!audioOn" size="25") mdi-microphone-off
                v-icon(v-else size="25") mdi-microphone
              v-btn(:disabled="hangUpBtn" small @click="hangUp" color="error")
                | Salir
          v-card(flat).ma-0
            v-list-item(three-line="").pa-0.pl-2
              v-list-item-avatar(size="80")
                v-img(:src="shop.data.img.imageInput1")
              v-list-item-content
                .headline-3 {{shop.data.name}}
                v-list-item-title Colaborador
                v-list-item-subtitle(v-if="tenderName") {{tenderName}}
                v-skeleton-loader(v-else :loading="true" transition="scale-transition" type="list-item")
          PreviewBasket.preview-basket
        v-col(cols="12" md="6").virtual-showcase.pl-2
          div(style="position:relative").virtual-showcase__title
            h2.mx-auto.text-center Vitrina virtual
          .container.card-products.card-product-rtc(v-if="cartProducts.length > 0")
            template(v-for="(item, index) in cartProducts")
              v-card(:key="item.product.id").product-card.ma-2
                p.product-card__tag(style=" margin-bottom: 0px;") {{item.product.name}}
                .product-card__content
                  .product-card__background
                      v-img(v-if="item.product.pictures" contain height='60px' :src='item.product.pictures.imageInput1')
                  .product-card__money-tag
                    span.product-card__money-tag__sign $
                    span {{item.product.price.sale | numberFormat}}
                .product-card__addBtn(@click="addToCart(item.product)")
                  .product-card__addBtn-container
                    span +
          .container(v-else)
            noResults( :title="'Aqui aparecen los productos que agregue el colaborador'" :description="''")
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'VideoChat',
    data () {
      return {
        dialog: false,
        cameraBtn : false,
        createRoomBtn : true,
        joinRoomBtn : true,
        hangUpBtn : true,
        configuration: {
          iceServers: [
            {
              urls: [
                'stun:stun1.l.google.com:19302',
                'stun:stun2.l.google.com:19302',
              ],
            },
          ],
          iceCandidatePoolSize: 10,
        },
        peerConnection: null,
        localStream: null,
        remoteStream: null,
        roomDialog: null,
        roomId: null,
        cameraOn: true,
        audioOn: false,
        cartProducts: [],
        tenderName: '',
        snackbar: {
          show: false,
          color: '',
          message: '',
        },
        status: ''
      }
    },
    filters: {
      numberFormat (val) {
        if (val) {
          const fixed = Number.parseFloat(val).toFixed(0)
          return fixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        } else return '0'
      },
    },
    components:{
      PreviewBasket: () => import('@/views/marketplace/components/PreviewBasket'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    computed: {
      shop () {
        // console.log(this.$store.state.storefront.currentShop)
        return this.$store.state.storefront.currentShop
      },
      user () {
        return this.$store.state.users.user
      },
      profile () {
        return this.$store.state.users.profile
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    mounted () {
      const vm = this
      vm.openUserMedia()
    },
    methods: {
      init () {
      },
      async createRoom () {
        const vm = this
        // console.log(vm.shop)
        vm.createRoomBtn = true
        vm.joinRoomBtn = true
        const db = firebase.firestore()
        const roomRef = await db.collection('rooms').doc(vm.shop.id).collection('calls').doc(vm.user.uid);
        vm.peerConnection = new RTCPeerConnection(vm.configuration)
        vm.registerPeerConnectionListeners()
        try {
            vm.localStream.getTracks().forEach(track => {
              vm.peerConnection.addTrack(track, vm.localStream);
            })
    
            // Code for collecting ICE candidates below
            const callerCandidatesCollection = roomRef.collection('callerCandidates');
    
            vm.peerConnection.addEventListener('icecandidate', event => {
              if (!event.candidate) {
                // console.log('Got final candidate!');
                return;
              }
              // console.log('Got candidate: ', event.candidate);
              callerCandidatesCollection.add(event.candidate.toJSON());
            });
            // Code for collecting ICE candidates above
    
            // Code for creating a room below
            const offer = await vm.peerConnection.createOffer();
            await vm.peerConnection.setLocalDescription(offer);
            // console.log('Created offer:', offer);
    
            const roomWithOffer = {
              'user':{
                name: vm.profile.name.concat(" ", vm.profile.last_name),
                email: vm.user.email,
              },
              'offer': {
                type: offer.type,
                sdp: offer.sdp,
              },
            };
            // console.log(roomWithOffer)
            await roomRef.set(roomWithOffer);
            vm.roomId = roomRef.id;
            // console.log(`New room created with SDP offer. Room ID: ${roomRef.id}`);
            // Code for creating a room above
    
            vm.peerConnection.addEventListener('track', event => {
              // console.log('Got remote track:', event.streams[0]);
              event.streams[0].getTracks().forEach(track => {
                // console.log('Add a track to the remoteStream:', track);
                vm.remoteStream.addTrack(track);
              });
            });
        } catch (error) {
          // console.log(error)
        }

        // Listening for remote session description below
        roomRef.onSnapshot(async snapshot => {
          const data = snapshot.data();
          if (!vm.peerConnection.currentRemoteDescription && data && data.answer) {
            vm.tenderName = data.tender.name
            const rtcSessionDescription = new RTCSessionDescription(data.answer);
            await vm.peerConnection.setRemoteDescription(rtcSessionDescription);
          }
        });
        // Listening for remote session description above

        // Listen for remote ICE candidates below
        roomRef.collection('callerCandidates').onSnapshot(snapshot => {
          snapshot.docChanges().forEach(async change => {
            // console.log(change)
            if (change.type === 'added') {
              let data = change.doc.data();
              //- // console.log(`Got new remote ICE candidate: ${JSON.stringify(data)}`);
              await vm.peerConnection.addIceCandidate(new RTCIceCandidate(data));
            }
          });
        });

        // Listen for remote ICE candidates below
        roomRef.collection('cart').onSnapshot(snapshot => {
          vm.cartProducts = []
          snapshot.forEach(function(doc) {
            vm.cartProducts.push(doc.data());
          })
        });
      },
      async joinRoomById (roomId) {
        // console.log(roomId)
        const vm = this
        const db = firebase.firestore()
        const roomRef = db.collection("rooms").doc(vm.shop.id).collection('calls').doc(`${roomId}`)
        const roomSnapshot = await roomRef.get()
        // console.log('Got room:', roomSnapshot.exists)
        vm.dialog = false

        if (roomSnapshot.exists) {
          vm.peerConnection = new RTCPeerConnection(vm.configuration)
          vm.registerPeerConnectionListeners()
          vm.localStream.getTracks().forEach(track => {
            vm.peerConnection.addTrack(track, vm.localStream)
          })

          // Code for collecting ICE candidates below

          // Code for collecting ICE candidates above

          vm.peerConnection.addEventListener('track', event => {
            // console.log('Got remote track:', event.streams[0])
            event.streams[0].getTracks().forEach(track => {
              // console.log('Add a track to the remoteStream:', track)
              vm.remoteStream.addTrack(track)
            })
          })

          // Code for creating SDP answer below

          // Code for creating SDP answer above

          // Listening for remote ICE candidates below

          // Listening for remote ICE candidates above
        }
      },
      async openUserMedia (e) {
        const vm = this
        try {
          const stream = await navigator.mediaDevices.getUserMedia(
            { video: vm.cameraOn, audio: vm.audioOn})
          document.querySelector('#localVideo').srcObject = stream
          vm.localStream = stream
          vm.remoteStream = new MediaStream()
          document.querySelector('#remoteVideo').srcObject = vm.remoteStream
          vm.joinRoomBtn = false
          vm.createRoomBtn = false
          vm.hangUpBtn = false
          vm.cameraBtn = true
          vm.createRoom()
        } catch (error) {
          if (error) {
            vm.snackbar.color = 'error'
            vm.snackbar.message = 'No podemos acceder a la camara, por favor agregue los permisos necesarios'
            vm.snackbar.show = true
            setTimeout(function () {
              vm.$emit('closeRTC')
            }, 5000);
          }
        }
      },
      async openCamera () {
        const vm = this
        vm.cameraOn = !vm.cameraOn
        if (!vm.cameraOn) {
          await document.querySelector('#localVideo').pause()
        } else {
          await document.querySelector('#localVideo').play()
        }
        /* const stream = await navigator.mediaDevices.getUserMedia(
          { video: vm.cameraOn, audio: vm.audioOn})
        document.querySelector('#localVideo').srcObject = stream
        vm.localStream = stream */
      },
      async openAudio () {
        const vm = this
        vm.audioOn = !vm.audioOn
        const stream = await navigator.mediaDevices.getUserMedia(
          { video: vm.cameraOn, audio: vm.audioOn})
        document.querySelector('#localVideo').srcObject = stream
        vm.localStream = stream
      },
      async deleteRoom () {
        const vm = this
        const db = firebase.firestore()
        const cartRef = db.collection("rooms").doc(vm.shop.id).collection('calls').doc(vm.user.uid)
        await cartRef.get().then(async function(doc) {
          // console.log(doc.data())
          if (doc.exists) {
            if (doc.data().answer && doc.data().exitTender){
              // console.log('Eliminar cuarto por cerrada del user')
              // Eliminar productos
              await cartRef.collection('cart').get().then(async function(cart) {
                await cart.docs.forEach(async (doc) => {
                  await cartRef.collection('cart').doc(doc.ref.id).delete()
                })
              })
              //- Eliminar candidatos
              await cartRef.collection('callerCandidates').get().then(async function(candidates) {
                await candidates.docs.forEach(async (doc) => {
                  // console.log(doc.ref.id)
                  await cartRef.collection('callerCandidates').doc(doc.ref.id).delete()
                })
              })
              // Eliminar room
              await cartRef.delete().then(async (res) => {
                // console.log('eliminar')
                await vm.$emit('closeRTC')
              })
            } else if (doc.data().answer) {
              // console.log('agregar true de cliente')
              const exit = {
                exitClient: true
              }
              await cartRef.update(exit).then(async ()=>{
                await vm.$emit('closeRTC')
              })
            } else {
              // console.log('Eliminar cuarto')
              //- Eliminar candidatos
              await cartRef.collection('callerCandidates').get().then(async function(candidates) {
                await candidates.docs.forEach(async (doc) => {
                  // console.log(doc.ref.id)
                  await cartRef.collection('callerCandidates').doc(doc.ref.id).delete()
                })
              })
              // Eliminar room
              await cartRef.delete().then(async (res) => {
                // console.log('eliminar')
                await vm.$emit('closeRTC')
              })
            }
          } else {
            // console.log("No such document!");
            await vm.$emit('closeRTC')
          }
        }).catch(async function(error) {
          // console.log("Error getting document:", error);
          await vm.$emit('closeRTC')
        });
      },
      async hangUp () {
        const vm = this
        const db = firebase.firestore()
        try {
          const tracks = await document.querySelector('#localVideo').srcObject.getTracks()
          tracks.forEach(async track => {
            await track.stop()
          })
  
          if (vm.remoteStream) {
            vm.remoteStream.getTracks().forEach(track => track.stop())
          }
  
          if (vm.peerConnection) {
            vm.peerConnection.close()
          }
          vm.joinRoomBtn= true
          vm.createRoomBtn = true
          vm.hangUpBtn = true
          vm.cameraBtn = false
          // Delete room on hangup
          vm.deleteRoom()
        } catch(error){
          vm.deleteRoom()
        }
      },
      registerPeerConnectionListeners () {
        // console.log('register per')
        const vm = this
        vm.peerConnection.addEventListener('icegatheringstatechange', () => {
          console.log(
            `ICE gathering state changed: ${vm.peerConnection.iceGatheringState}`)
            switch(vm.peerConnection.iceGatheringState) {
              case 'complete':
                vm.status = 'Llamada en espera'
              break;
            }
        })

        vm.peerConnection.addEventListener('connectionstatechange', () => {
          // console.log(`Connection state change: ${vm.peerConnection.connectionState}`)
          switch(vm.peerConnection.connectionState){
            case 'connecting':
              vm.status = 'Conectando...'
            break;
            case 'disconnected':
              vm.status = 'Desconectado...'
            break;
            case 'failed':
              vm.status = 'Fallo de conexión.'
            break;
            case 'connected':
              vm.status = ''
            break;
          }
        })

        vm.peerConnection.addEventListener('signalingstatechange', () => {
          // console.log(`Signaling state change: ${vm.peerConnection.signalingState}`)
        })

        vm.peerConnection.addEventListener('iceconnectionstatechange ', () => {
          console.log(
            `ICE connection state change: ${vm.peerConnection.iceConnectionState}`)
        })
      },
      addToCart (product) {
        // // console.log(this.shop)
        const vm = this
        const inventoryShop = {
          id: this.shop.id,
          uid: this.shop.data.uid,
          name: this.shop.data.name,
          inventory: {
            amount: 1,
            data: product,
            id: product.id
          },
          context: 'video'
        }
        // console.log(inventoryShop)
        vm.$store.dispatch('pos/addToCart', inventoryShop).then(() => {
        })
      }
    },
    beforeDestroy () {
      const vm = this
      vm.hangUp()
    },
  }
</script>

<style scoped lang="scss">
  .rtc-close-btn{
    position:absolute; 
    top: 10px; 
    right: 10px; 
    margin-right: 0;
    z-index:1;
  }
  .web-rtc-container{
    max-height: calc(100vh - 41px) !important;
    overflow-y: auto;
  }
  .card-video {
    position: fixed;
    height: auto;
    @media screen and (max-width: 1024px) {
      height: 100%;
    }
  }
  .video {
    &__local{
      width: 100px;
      height: 100px;
      position:absolute;
      left: 0;
      bottom: 0;
    }
    &__remote{
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    &__status{
      position: absolute;
      top: 40%;
      font-size: large;
      left: 40%;
      z-index: 1;
      // color: white;
    }
    &:hover{
      .buttonsVideo{
        display: block;
      }
    }
  }

  @media screen and (max-width: 950px) {
    .virtual-showcase{
      border: none !important;
    }
    .preview-basket{
      position: absolute;
      z-index: 1;
      width: 100%;
      bottom: 0;
    }
  }


  .virtual-showcase{
    border: 1px solid #c4c0d8;
    border-radius: 20px;
    padding: 0;
    margin: 0;
    padding-bottom: 10px;
    padding-right: 0px;
    &__title{
      width: 50%;
      background: #009da5;
      border-radius: 0px 0px 50px 50px;
      color: white;
      margin: 0 auto;
    }
  }

  .buttonsVideo{
    display: none;
    position: absolute;
    top:0;
    right: 0;
    @media screen and (max-width: 950px) {
      bottom: 0 !important;
      top: unset;
    }
  }

  .card-product-rtc{
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 420px;
    padding-bottom: 50px;
  }

  .product-card{
    transition: .3s;
    display: flex;
    flex-direction:column;
    height: 100%;
    min-height: 120px;
    max-height: 160px;
    max-width: 150px;
    min-width: 150px;
    border-radius: 16px !important;
    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.3) !important;
    position: relative;
    overflow: hidden;
    &__tag {
      line-height: 15px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 0;
      min-height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;

      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }
    &__container{
      padding-bottom: 35px;
      max-height: 76vh;
      overflow-y: auto;
      @media(min-width: 768px){
        height: 100%;
        overflow: auto;
      }
    }
    &__content{
      padding: 10px;
     //
    }
    &__background{
      max-height: 70px;
      width: 100px;
      margin: auto;
      overflow: hidden;
      border-radius: 12px;
     //
    }
    &__money-tag{
      font-size: 1em;
      font-weight: bold;
      &__sign{
        color: #01b9c0;
        margin-right: 5px;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 44px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 100px;
        height: 85px;
        margin-right: -35px;
        margin-bottom: -35px;
        background: #00b9c0;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;
        display: flex;
        flex-direction: column;
        span{
          font-size: 35px;
          margin-top: 5px;
          margin-left: 3px;
        }
      }
    }
  }
  .basket-btn {
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__container {
      bottom: 0;
      right: 0;
      left: 0;
      max-width: 100%;
      margin: 0 auto;
      background: inherit;
      &.isCart{
        bottom: 50px;
      }
      @media(min-width: 1024px){
        &.isCart {
          bottom: -60px;
        }
        &.modal-cart{
        background: transparent;
        right: 0;
        margin: 0;
        margin-left: auto;
        }
      }
    }
  }
  .store-cart{
    position: fixed;
    bottom: 0;
  }
  .store-title{
    display: flex;
    flex-direction: row;
  }

</style>
